// extracted by mini-css-extract-plugin
module.exports = {"container":"SignInWithGoogle_container__Jnus_","googleLoginButton":"SignInWithGoogle_googleLoginButton__HO4C3"};